// extracted by mini-css-extract-plugin
export default {"card":"NoPlans_card__EDSkf","title":"NoPlans_title__t8H23","button":"NoPlans_button__EPSty"};